class NumberUtils {
  removeSeparators(str: string) {
    return str.replace(/,/g, '')
  }
}

const numberUtils = new NumberUtils()

export default numberUtils
